export default "__VITE_ASSET__kh3yBSjA__"